import { Injectable } from '@angular/core'
import { FirestoreService } from '../../shared/modules/fire/firestore.service'
import { AppUser } from '../../../../domain/user/app-user.model'

@Injectable({ providedIn: 'root' })
export class AppUsersFirestoreService extends FirestoreService<AppUser> {
	constructor() {
		super()
	}

	protected resolvePath(): string {
		return 'users'
	}
}
